import React from "react";
import { CheckCircle2, Home, Hammer, Building2, Factory, Wrench } from "lucide-react";
import { Button } from "./ui/button";
import { PROPERTY_TYPES } from "../mock";

const ICONS = {
  residential: Home,
  renovations: Hammer,
  commercial: Building2,
  industrial: Factory,
  installations: Wrench,
};

export default function PropertyTypes({ onGetQuote }) {
  return (
    <section id="property-types" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-[#0a4f8a] text-xs font-bold uppercase tracking-wider mb-3">
            Who We Service
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a4f8a] mb-3">
            Residential, Commercial &amp; Industrial Plumbing
          </h2>
          <p className="text-slate-600">
            Whether it's a leaking tap in your home, a full bathroom renovation, a café fit-out
            or large-scale industrial pipework — Cheerings handles it all.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {PROPERTY_TYPES.map((p) => {
            const Icon = ICONS[p.id] || Wrench;
            return (
              <div
                key={p.id}
                className="card-lift bg-gradient-to-b from-white to-sky-50/50 border border-slate-100 rounded-2xl p-6 flex flex-col"
              >
                <div className="w-12 h-12 rounded-lg bg-[#0a4f8a] flex items-center justify-center mb-4">
                  <Icon size={22} className="text-sky-300" />
                </div>
                <h3 className="font-extrabold text-[#0a4f8a] text-lg mb-2">{p.title}</h3>
                <p className="text-sm text-slate-600 mb-4 flex-1">{p.description}</p>
                <ul className="space-y-2 mb-5">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-xs text-slate-700">
                      <CheckCircle2 size={14} className="text-sky-600 shrink-0 mt-0.5" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  onClick={() => onGetQuote(p)}
                  className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold text-sm"
                >
                  Get a Quote
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
